import { render, staticRenderFns } from "./CertificationsDetails.vue?vue&type=template&id=1bb1f4a2&"
import script from "./CertificationsDetails.vue?vue&type=script&lang=js&"
export * from "./CertificationsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports